import OrderSubmitted from './OrderSubmitted.component';

export default OrderSubmitted;
